/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
import type { layoutCorpoData$ref } from "./layoutCorpoData.graphql";
export type PaymentCorpoEraseAllMutationVariables = {|
  corpoRef: string
|};
export type PaymentCorpoEraseAllMutationResponse = {|
  +payment: ?{|
    +corpo: ?{|
      +res: ?{|
        +code: number,
        +message: string,
        +corpoNode: ?{|
          +$fragmentRefs: layoutCorpoData$ref
        |},
      |}
    |}
  |}
|};
export type PaymentCorpoEraseAllMutation = {|
  variables: PaymentCorpoEraseAllMutationVariables,
  response: PaymentCorpoEraseAllMutationResponse,
|};
*/


/*
mutation PaymentCorpoEraseAllMutation(
  $corpoRef: String!
) {
  payment {
    corpo {
      res: eraseAllPaymentMethods(corpoRef: $corpoRef) {
        code
        message
        corpoNode {
          ...layoutCorpoData
          id
        }
      }
    }
  }
}

fragment layoutCorpoData on Corpo {
  ref
  name
  fidelityLevel
  isFidelityActive
  subscription
  fidelityProgress {
    year
    yearBookings
    bookingsToNextTier
    bookingsToMaintain
    validUntil
  }
  teamName
  formatted_address
  siret
  tvaNumber
  invoiceEmails
  params {
    allowEmailDomain
    automaticApprouval
    manualApprouval
    automaticDeniedOtherEmailDomain
    manualOtherEmailDomain
  }
  payment {
    isSepa
    transferMode
    mandateUrl
  }
  users {
    ref
    roles
    status
    email
    user {
      email
      lastname
      firstname
      id
    }
    adminNeedValid: is(what: NEEDAPPROVAL)
    emails {
      template
      limitDate
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "corpoRef"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "corpoRef",
    "variableName": "corpoRef"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ref",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PaymentCorpoEraseAllMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PaymentMutation",
        "kind": "LinkedField",
        "name": "payment",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PaymentCorpoMutation",
            "kind": "LinkedField",
            "name": "corpo",
            "plural": false,
            "selections": [
              {
                "alias": "res",
                "args": (v1/*: any*/),
                "concreteType": "PaymentPaymentPayload",
                "kind": "LinkedField",
                "name": "eraseAllPaymentMethods",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Corpo",
                    "kind": "LinkedField",
                    "name": "corpoNode",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "layoutCorpoData"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PaymentCorpoEraseAllMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PaymentMutation",
        "kind": "LinkedField",
        "name": "payment",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PaymentCorpoMutation",
            "kind": "LinkedField",
            "name": "corpo",
            "plural": false,
            "selections": [
              {
                "alias": "res",
                "args": (v1/*: any*/),
                "concreteType": "PaymentPaymentPayload",
                "kind": "LinkedField",
                "name": "eraseAllPaymentMethods",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Corpo",
                    "kind": "LinkedField",
                    "name": "corpoNode",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "fidelityLevel",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isFidelityActive",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "subscription",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CorpoFidelityProgress",
                        "kind": "LinkedField",
                        "name": "fidelityProgress",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "year",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "yearBookings",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "bookingsToNextTier",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "bookingsToMaintain",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "validUntil",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "teamName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "formatted_address",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "siret",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "tvaNumber",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "invoiceEmails",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CorpoParams",
                        "kind": "LinkedField",
                        "name": "params",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "allowEmailDomain",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "automaticApprouval",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "manualApprouval",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "automaticDeniedOtherEmailDomain",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "manualOtherEmailDomain",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CorpoPayment",
                        "kind": "LinkedField",
                        "name": "payment",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isSepa",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "transferMode",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "mandateUrl",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CorpoUser",
                        "kind": "LinkedField",
                        "name": "users",
                        "plural": true,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "roles",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "status",
                            "storageKey": null
                          },
                          (v5/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "lastname",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "firstname",
                                "storageKey": null
                              },
                              (v6/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": "adminNeedValid",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "what",
                                "value": "NEEDAPPROVAL"
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "is",
                            "storageKey": "is(what:\"NEEDAPPROVAL\")"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CorpoUserEmail",
                            "kind": "LinkedField",
                            "name": "emails",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "template",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "limitDate",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "21353e86ec5e78ab7daa2f8e4a85f9e5",
    "id": null,
    "metadata": {},
    "name": "PaymentCorpoEraseAllMutation",
    "operationKind": "mutation",
    "text": "mutation PaymentCorpoEraseAllMutation(\n  $corpoRef: String!\n) {\n  payment {\n    corpo {\n      res: eraseAllPaymentMethods(corpoRef: $corpoRef) {\n        code\n        message\n        corpoNode {\n          ...layoutCorpoData\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment layoutCorpoData on Corpo {\n  ref\n  name\n  fidelityLevel\n  isFidelityActive\n  subscription\n  fidelityProgress {\n    year\n    yearBookings\n    bookingsToNextTier\n    bookingsToMaintain\n    validUntil\n  }\n  teamName\n  formatted_address\n  siret\n  tvaNumber\n  invoiceEmails\n  params {\n    allowEmailDomain\n    automaticApprouval\n    manualApprouval\n    automaticDeniedOtherEmailDomain\n    manualOtherEmailDomain\n  }\n  payment {\n    isSepa\n    transferMode\n    mandateUrl\n  }\n  users {\n    ref\n    roles\n    status\n    email\n    user {\n      email\n      lastname\n      firstname\n      id\n    }\n    adminNeedValid: is(what: NEEDAPPROVAL)\n    emails {\n      template\n      limitDate\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '150e84a43bcead5cb252c85215c5454f';

module.exports = node;
